import React, { Component } from "react";
import styled from "styled-components";

import { Table as BootstrapTable } from "reactstrap";

import TableHeader from "./TableHeader";
import NumberOfItems from "./NumberOfItems";
import Pagination from "./Pagination";

class Table extends Component {
  render() {
    const { labels, children, setSort, setPage, params, meta } = this.props;
    return (
      <Wrapper>
        <StyledTable striped hover responsive>
          <thead>
            <tr>
              {labels.map(label => (
                <TableHeader
                  key={label.title}
                  {...label}
                  currentSortField={params.get("sortField")}
                  currentSortDir={params.get("sortDir")}
                  setSort={setSort}
                />
              ))}
            </tr>
          </thead>
          <tbody>{children}</tbody>
        </StyledTable>
        <TableFooter>
          <NumberOfItems params={params} meta={meta} />
          <Pagination
            numberOfPages={
              meta && Math.ceil(meta.get("all") / params.get("limit"))
            }
            currentPage={params.get("currentPage")}
            maxPagesDisplay={5}
            setPage={setPage}
          />
        </TableFooter>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`width: 100%;`;

const StyledTable = styled(BootstrapTable).attrs({
  className: "text-dark"
})`font-size: 13px;`;

const TableFooter = styled.div.attrs({
  className: "text-dark"
})`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  font-size: 13px;
  border-top: 1px solid #c2cfd6;
`;

export default Table;



// WEBPACK FOOTER //
// ./src/components/Table/Table.js